import { TradesDurationSettingsDialog } from './trades-duration-settings-dialog';
import { DIALOG } from '../dialog-combiner';
import { userModals } from 'core/User/modal.config';
import { transitions } from '../transition.config';

DIALOG.add(userModals.TRADES_DURATIONS_SETTINGS, {
  component: TradesDurationSettingsDialog,
  transition: transitions.SLIDE_UP,
  anchor: 'portal',
});
